<template>
  <el-container class="container" style="min-width: 1200px">
    <!-- header -->
    <div class="header" style="">
      <el-row>
        <!-- <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="header-left">
          <h4>
            {{ $t('nav.welcome1') }} <br />
            {{ $t('nav.welcome2') }}
          </h4>
          <h5>{{ $t('nav.date') }}</h5>
          <h5>{{ $t('nav.address') }}</h5>
        </el-col> -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="header-middle clearfix">
          <!-- <img src="./assets/img/banner.jpg" alt="" /> -->
          <img :src="$t('head.img')" height="360"/>
        </el-col>
        <!-- <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="header-right"></el-col> -->
      </el-row>
    </div>
    <!-- 主菜单 -->
    <el-main class="main">
      <el-menu
        :default-active="$route.path"
        mode="horizontal"
        @select="handleSelect"
        background-color="#c5374c"
        text-color="#fff"
        active-text-color="#fff"
        class="menu"
      >
        <el-menu-item index="/">{{ $t('nav.tit-home') }}</el-menu-item>
        <el-menu-item index="/Organization">{{ $t('nav.titOrganization') }}</el-menu-item>
        <el-menu-item index="/Committee">{{ $t('nav.titCommittee') }}</el-menu-item>
        <el-menu-item index="/submissions">{{ $t('nav.titSubmissions') }}</el-menu-item>
        <el-menu-item index="/program">{{ $t('nav.titProgram') }}</el-menu-item>
        <el-menu-item index="/registration">{{ $t('nav.titRegistration') }}</el-menu-item>
<!--        <el-menu-item index="/travel">{{ $t('nav.titTravel') }}</el-menu-item>-->
        <el-menu-item index="/contact">{{ $t('nav.titContact') }}</el-menu-item>
        <!-- <el-menu-item index="/register">{{ $t('nav.register') }}</el-menu-item> -->
      </el-menu>
      <div class="langSel">
        <el-select v-model="selectValue" @change="langChange" :placeholder="$t('nav.titPlaceholder')">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
    </el-main>
    <!-- 路由页面 -->
    <router-view />

<!-- 提示信息 -->
<!-- <div  id="box"  style="z-index: 100;
  display:none;
    right:10px;
    position: fixed; 
    bottom: 20px; 
    background-color: #fff;
    width:400px; 
    border-radius:5px;
    padding: 30px 10px;
    background-color: #fff;
     text-align: center;
    box-shadow: 1px 1px 50px rgb(0 0 0 / 30%);">
  <div style="font-size:25px;border-bottom: 1px solid #F0F0F0;padding:15px;color:#c5374c">{{$t('footer.message1')}} </div>
  <div id="layerDemorb" class="layui-layer-content">
    <br>
    <div style="font-size:18px;padding:30px">{{$t('footer.message2')}} </div>
    </div>
    <button style="border-color: #c5374c;
    background-color: #c5374c;
    color: #fff;width:80px;height:45px;border:none;border-radius:8px" @click="handleHidenBox">{{$t('footer.message3')}}</button>
  </div> -->

    <!-- footer -->
    <el-footer height="100px" class="footer">
      <div class="copyright">{{ $t('footer.copyright') }}</div>
    </el-footer>
    <!-- 回到顶部 -->
    <el-backtop class="backtop"></el-backtop>
  </el-container>
</template>

<style lang="less">
@cyan: #176998;
.langSel {

  float: right;
  height: 100%;
  margin-right: 2em;
  .el-input__inner {
    height: 60px;
    background-color: #c5374c;
    border: none;
    color: white;
    width: 100px;
  }
}
.container {
  .header {
    padding: 0;
    // margin: 10px 0;
    height: 100%;
    .el-col {
      overflow: hidden;
    }
    .header-left {
      h4,
      h5 {
        width: 100%;
        text-align: left;
      }
      h4 {
        margin-bottom: 10px;
        line-height: 30px;
        font-size: 24px;
        color: @cyan;
      }
      h5 {
        line-height: 20px;
        font-size: 18px;
        color: #484848;
      }
    }
    .header-middle {
      background-size: cover;
      background-position: bottom center;
      background-repeat: no-repeat;
      img {
        width: 100%;
      }
      .headImg {
        width: 100%;
      }
    }
    .header-right {
      padding: 10px;
      background-image: url(./assets/img/logo.jpg);
      background-size: contain;
      background-position: bottom right;
      background-repeat: no-repeat;
      background-origin: content-box;
    }
  }
  .main {
    height: 60px;
    padding: 0;
    text-align: center;
    overflow: hidden;
    // background-color: @cyan;
    background-color: #c5374c;
    .menu {
      display: inline-block;
      height: 60px;
      border: 0;
      .el-menu-item {
        font-size: 16px;
        color: #fff;
        background-color: #c5374c;
        :not(.is-disabled):hover {
          color: black !important;
        }
      }
    }
  }
  .footer {
    // background-color: @cyan;
    background-color: #c5374c;
    overflow: hidden;
    .copyright {
      height: 100px;
      line-height: 100px;
      text-align: center;
      font-size: 20px;
      color: #fff;
    }
  }
  .backtop {
    width: 60px;
    height: 60px;
    color: @cyan;
  }
}
</style>

<script>
export default {
  name: 'App',
  data() {
    return {
      selectValue: 'cn',
      options: [
        {
          value: 'cn',
          label: '中文'
        },
        {
          value: 'en',
          label: 'English'
        }
      ],
      activeIndex: '/'
    }
  },
  mounted() {
    let lang = localStorage.getItem('lang')
    if (lang) {
      this.$i18n.locale = lang
      this.selectValue = lang
    } else {
      localStorage.setItem('lang', 'cn')
      this.$i18n.locale = localStorage.getItem('lang')
      this.selectValue = localStorage.getItem('lang')
    }
  },
  methods: {
    handleHidenBox(){
      document.getElementById("box").style.display="none";
      
    },
    handleSelect(key, keyPath) {
      this.$router.push(key)
    },
    //语言切换
    langChange(e) {
      localStorage.setItem('lang', e)
      this.$i18n.locale = e
    }
  }
}
</script>
